import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { unscheduleTeamDeletionThunk } from './teamSlice';
import { RootState } from '../../reducers';
import { setAlertMessage } from '../dashboard/dashboardSlice';

const TeamDeletionCover = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { deleteRequestedAt, teamId, name } = useSelector(
    (state: RootState) =>
      state.team.selectedTeam || {
        deleteRequestedAt: '',
        teamId: '',
        name: '',
      },
  );

  if (!deleteRequestedAt || !teamId) {
    return null;
  }

  const deleteRequestedMoment = moment(deleteRequestedAt);
  const deletionDate = moment(deleteRequestedMoment).add(14, 'days');
  const currentDate = moment();
  const daysRemaining = deletionDate.diff(currentDate, 'days');

  const handleRestore = async () => {
    await dispatch(unscheduleTeamDeletionThunk(teamId));
    dispatch(
      setAlertMessage({
        type: 'success',
        message: t('teamDeletion.restored', { teamName: name }),
      }),
    );
  };

  return (
    <div className="flex justify-center items-center h-[70vh] bg-background">
      <div className="p-8 rounded flex flex-col items-center justify-center w-full max-w-full text-center">
        <h2 className="text-xl font-semibold mb-2 text-primary">
          {t('teamDeletion.title')}
        </h2>
        <p className="text-base mb-3">
          {t('teamDeletion.description', { daysRemaining })}
        </p>
        <Button onClick={handleRestore}>{t('teamDeletion.restore')}</Button>
      </div>
    </div>
  );
};

export default TeamDeletionCover;
